import { createContext, useContext } from "react";

/* フッタの下段に並べる、リンクの多い区画 (可視化、言語、Git コマンドなど)。中身はアプリ側が持つ一覧から作って渡す */
export type PageFooterSection = {
  id: string;
  heading: string;
  allHref: string;
  /* 別アプリの住所 (/security/ など)。アプリ内の遷移にせず、素の a で開く */
  external?: boolean;
  /* label が空の組は、見出しなしで並べる */
  groups: { label: string; links: { title: string; href: string }[] }[];
};

const PageFooterSectionsContext = createContext<readonly PageFooterSection[]>([]);

export const PageFooterSectionsProvider = PageFooterSectionsContext.Provider;

export function usePageFooterSections() {
  return useContext(PageFooterSectionsContext);
}
